import { render, staticRenderFns } from "./PhaseFormComponent.vue?vue&type=template&id=30b0b7fd"
import script from "./PhaseFormComponent.vue?vue&type=script&lang=js"
export * from "./PhaseFormComponent.vue?vue&type=script&lang=js"
import style0 from "./PhaseFormComponent.vue?vue&type=style&index=0&id=30b0b7fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports